import { render } from "./BulkDatabaseTaskView.vue?vue&type=template&id=0b162958&ts=true"
import script from "./BulkDatabaseTaskView.vue?vue&type=script&lang=ts"
export * from "./BulkDatabaseTaskView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__